// These are your personal OTPs - keep them safe
export const VALID_OTPS = new Set([
  '847392', '163549', '925714', '478361', '591634',
  '284957', '736182', '419573', '852946', '374815',
  '693247', '518934', '247856', '961384', '735921',
  '428673', '159482', '864231', '392567', '715843'
]);

// Keep track of used OTPs
export const USED_OTPS = new Set();

export function validateOTP(otp) {
  // Check if OTP exists and hasn't been used
  if (VALID_OTPS.has(otp) && !USED_OTPS.has(otp)) {
    // Mark OTP as used
    USED_OTPS.add(otp);
    return true;
  }
  return false;
}

// Add a new OTP
export function addOTP(otp) {
  if (otp.length === 6 && /^\d+$/.test(otp)) {
    VALID_OTPS.add(otp);
    return true;
  }
  return false;
}

// Remove an OTP
export function removeOTP(otp) {
  return VALID_OTPS.delete(otp);
}

// Clear all used OTPs
export function resetUsedOTPs() {
  USED_OTPS.clear();
} 